import { NavLink, useNavigate } from 'react-router-dom';
import {
  FiHome,
  FiBook,
  FiPlay,
  FiVideo,
  FiMusic,
  FiHeadphones,
  FiHelpCircle,
  FiLogOut
} from 'react-icons/fi';
const StudentSidebar = ({ isMobileOpen, onMobileClose, isCollapsed, setIsCollapsed }) => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };
  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 z-[997] bg-black/50 md:hidden"
          onClick={onMobileClose}
        />
      )}
      <aside className={`
    fixed left-0 z-[998]
    flex flex-col gap-4
    bg-white border-r border-gray-200
    py-6
    min-h-[calc(100vh-62px)]
    transition-all duration-300
    ${isMobileOpen ? "left-0" : "-left-full md:left-0"}
    ${isCollapsed
          ? "md:w-20 w-20"
          : "md:w-[280px] w-0"}
  `}>
        <div className={`flex flex-col flex-1 ${!isCollapsed ? "w-0 overflow-hidden md:w-auto md:overflow-visible" : ""}`}>

          {/* Mobile Close */}
          <button
            onClick={onMobileClose}
            className="absolute right-4 top-4 z-[999] hidden h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-[#0f6abf] text-white shadow md:hidden"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          {/* Collapse Toggle */}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className={`absolute ${isCollapsed ? "-right-3" : '-right-6'} md:-right-3 top-1 z-[999]  h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-[#e8f0f7] text-[#0f6abf] shadow transition hover:scale-110 flex`}
          >
            {isCollapsed ? (
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            ) : (
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            )}
          </button>
          <div className={`px-4 transition-all ${isCollapsed && "px-3"}`}>
            {[
              { to: "/student", icon: <FiHome />, label: "Dashboard" },
              { to: "/student/courses", icon: <FiBook />, label: "My Courses" },
              { to: "/student/playlist", icon: <FiPlay />, label: "Playlist (Free Courses)" },
              { to: "/student/videos", icon: <FiVideo />, label: "Video Courses" },
              { to: "/student/audios", icon: <FiMusic />, label: "Audio Courses" },
              { to: "/student/podcasts", icon: <FiHeadphones />, label: "Podcast Courses" },
            ].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/student"} // only Dashboard exact match
                onClick={onMobileClose}
                className={({ isActive }) =>
                  `group relative mb-2 flex items-center gap-3 rounded-xl px-4 py-3 font-medium transition
         ${isCollapsed ? "justify-center px-3" : ""}
         ${isActive ? "bg-[#e8f0f7] text-[#0f6abf]" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"}`
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={`w-8 h-8 rounded-xl flex items-center justify-center text-lg
              ${isActive ? "bg-white text-[#0f6abf]" : "bg-gray-100 text-gray-600"}`
                      }
                    >
                      {item.icon}
                    </span>
                    {!isCollapsed && (
                      <div className="flex flex-col">
                        <span className="text-sm font-medium">{item.label}</span>
                      </div>
                    )}
                  </>
                )}
              </NavLink>

            ))}
          </div>
          {/* Footer */}
          <div className="mt-auto p-4 border-t border-gray-100">
            {/* Help & Support */}
            <button
              className={`w-full flex items-center p-3 text-gray-600 rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all duration-200 ${isCollapsed ? "justify-center" : ""
                }`}
            >
              <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
                <FiHelpCircle className="text-lg text-gray-600" />
              </div>
              {!isCollapsed && (
                <span className="ml-3 font-medium text-sm">Help & Support</span>
              )}
            </button>
            {/* Logout */}
            <button
              onClick={logout}
              className={`w-full flex items-center p-3 text-gray-600 rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all duration-200 mt-2 ${isCollapsed ? "justify-center" : ""
                }`}
            >
              <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
                <FiLogOut className="text-lg text-gray-600" />
              </div>
              {!isCollapsed && (
                <span className="ml-3 font-medium text-sm">Logout</span>
              )}
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default StudentSidebar;